module.exports = __webpack_public_path__ + "static/media/horse.b44de1f4.svg";